export default __webpack_public_path__ + "static/media/loadingFullScreen.770c3190.gif";